module.exports = __webpack_public_path__ + "static/img/5.b1f7a7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/5.png
// module id = JlFx
// module chunks = 0